import { createContext, useState } from 'react';

type PaymentMethod = {
  fee: number;
  active: boolean;
  showWhenInactive?: boolean;
  daysBeforeExpiration?: number;
  daysBeforeEndOfMonth?: number;
  daysAfterDueDate?: number;
};

type MerchantContextType = {
  merchant?: {
    id: string;
    logoUrl: string;
    supportEmail: string;
    supportWhatsapp: string;
    customButton?: {
      backgroundColor: string;
      color?: string;
    };
    dashboardImageUrl?: string;
    termsUrl?: string;
    enforceOrderedPayments?: boolean;
    allowsPartialPayment?: boolean;
    paymentMethods: {
      card: PaymentMethod;
      pse: PaymentMethod;
      nequiButton: PaymentMethod;
      bancolombiaButton: PaymentMethod;
      breb: PaymentMethod;
      cash: PaymentMethod;
    };
    erp: 'simi' | 'empatia' | 'nuwwe' | 'mobilia' | 'sedi' | 'nuby' | 'pentagono' | 'orbis' | 'none' | 'tayrona' | 'netgeo' | 'helisa' | 'paco';
    popupImage?: {
      imageUrl: string;
      redirectUrl?: string;
    };
    cardFeeMessage?: string;
    cardActivationDaysBeforeExpiration?: number;
    paymentsPortalBanner?: {
      type?: 'success' | 'info' | 'warning' | 'error';
      title?: string;
      text: string;
      link?: string;
    };
    subscriptionConfig?: {
      enabled: boolean;
      revenueSharePercentage?: number;
      cobrandingDisabled?: boolean;
    };
    receiptFinePrint?: string;
    loginByContract?: boolean;
    disableCardInstallments?: boolean;
    cardFeeConfirmation?: boolean;
    hidePaymentDeadlines?: boolean;
    redirectOnLogout?: string;
    org?: {
      id: string;
      dashboardImageUrl?: string;
    };
    bancolombiaGateway?: boolean;
    bancolombiaButtonPreferred?: boolean;
  };
  setMerchant: (merchant: MerchantContextType['merchant']) => void;
};

const MerchantContext = createContext<MerchantContextType>({
  setMerchant: () => {},
});

const MerchantContextProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const [merchant, setMerchant] = useState<MerchantContextType['merchant'] | undefined>(undefined);
  return <MerchantContext.Provider value={{ merchant, setMerchant }}>{children}</MerchantContext.Provider>;
};
export default MerchantContext;

export { MerchantContextProvider };
